import type { AiAppCenterModule } from '../types'

export const businessModule: AiAppCenterModule = {
  key: 'business',
  label: 'AI商务社交',
  desc: '商务人脉 / 商圈互动 / 商机合作 / 社群运营',
  path: '/business',
  homePath: '/business/dashboard',
  icon: 'ep:connection',
  color: '#2563eb',
  aliases: ['商务社交', '老板圈', 'AI 商务社交']
}
